export default {
  // add data from calculator reduced
  setCalculatorReducedData: (context, payload) => {
    const { immobilienwert, wunschbetrag } = payload
    context.commit('SET_IMMOBILIENWERT', immobilienwert)
    context.commit('SET_WUNSCHBETRAG', wunschbetrag)
    context.commit('SET_WUNSCHBETRAG_MAX', immobilienwert)
    context.commit('SET_DATA_FROM_CALCULATOR_REDUCED')
  },
  setHausankerData: (context, data) => {
    context.commit('SET_HAUSANKER_DATA', data)
    context.commit('SET_DATA_FROM_CALCULATOR_REDUCED')
  },
  setDesign: (context, designName) => {
    context.commit('SET_DESIGN', designName)
  },
  setSalesforceDesign: (context, design) => {
    context.commit('SET_SALESFORCE_DESIGN', design)
  },

  toggleValidateInputs: context => {
    context.commit('SET_VALIDATE_INPUT')
  },

  connectLS: context => {
    context.commit('USE_LS')
  },

  setLS: context => {
    context.commit('SET_LS')
  },

  clearLS: context => {
    context.commit('CLEAR_LS')
  },

  setVariant: (context, payload) => {
    if (payload === 1) {
      context.commit('HIDE_SLIDE_24')
      context.commit('SET_VARIANT', 1)
    }
    if (payload === 2) {
      context.commit('HIDE_SLIDE_19')
      context.commit('HIDE_SLIDE_20')
      context.commit('SET_VARIANT', 2)
    }
  },

  setEl: (context, el) => {
    context.commit('SET_EL', el)
  },

  editCurrentSlide: (context, slideNum) => {
    context.commit('SET_CURRENT_SLIDE', slideNum)
  },

  editRadio: (context, payload) => {
    if (payload.slideName === context.state.slideNames.SLIDE_10) {
      context.commit('TOGGLE_ITEMS', payload)
    } else {
      context.commit('CLEAN_RADIO', payload)
    }
  },

  editHiddenInputs: (context, payload) => {
    context.commit('SET_HIDDEN_INPUT', payload)
  },

  editSlidesByPropertyType: (context, propertyType) => {
    context.commit('SKIP_SLIDE_0')
    context.commit('SET_PROPERTY_TYPE', propertyType)
    context.commit('SET_SLIDES_BY_PROPERTY_TYPE', propertyType)
  },

  editPropertyType: (context, propertyType) => {
    context.commit('SET_PROPERTY_TYPE', propertyType)
  },

  // SAVE USER INPUT FROM EVERY FORM
  saveData: (context, payload) => {
    if (payload.slideName === context.state.slideNames.SLIDE_1) {
      context.commit('SET_TAG_PROPERTY_VARIANT', payload.value)
    }
    if (payload.slideName !== context.state.slideNames.SLIDE_10) {
      context.commit('SET_DATA', payload)
    }

    // set property type
    if (payload.propertyType) {
      context.commit('SET_PROPERTY_TYPE', payload.propertyType)
      context.commit('SET_SLIDES_BY_PROPERTY_TYPE', payload.propertyType)
    }

    // set haus type -- for slide 13 additional options
    if (payload.hausType) {
      context.commit('SET_HAUS_TYPE', payload.hausType)
      context.commit('TOGGLE_ADDITIONAL_OPTIONS_SLIDE_13')
    }

    // SLIDE 2 - 1
    // set max value for form 2 and show
    if (
      payload.slideName === context.state.slideNames.SLIDE_2 &&
      payload.formName.name === context.state.formNames.FORM_2_1.name
    ) {
      context.commit('SET_VALUES_FORM_2_2', payload.value)
      context.commit('SET_IMMOBILIENWERT', payload.value)
      context.commit('SET_WUNSCHBETRAG_MAX', payload.value)
      context.commit('SET_HOHE_DER_LASTEN_VALUES', context.state.wunschbetrag)
    }

    if (
      payload.slideName === context.state.slideNames.SLIDE_2 &&
      payload.formName.name === context.state.formNames.FORM_2_2.name
    ) {
      context.commit('SET_WUNSCHBETRAG', payload.value)
      context.commit('SET_HOHE_DER_LASTEN_VALUES', payload.value)
    }

    // SLIDE 7
    if (
      payload.slideName === context.state.slideNames.SLIDE_7 &&
      payload.formName.name === context.state.formNames.FORM_7_2.name
    ) {
      context.commit('SET_ADDITIONAL_OPTIONS_SLIDE_7', payload)
    }

    // SLIDE 17
    // add or remove slide 18
    if (payload.slideName === context.state.slideNames.SLIDE_17) {
      let toRemove = true
      for (const key in payload.allValues) {
        if (
          payload.allValues[key] === 'teilweise' ||
          payload.allValues[key] === 'komplett'
        ) {
          toRemove = false
        }
      }
      if (toRemove) {
        context.commit('HIDE_SLIDE_18')
      } else {
        const slide18 = context.state.slides.find(
          slide => slide.slideName === context.state.slideNames.SLIDE_18
        )
        if (!slide18) {
          context.commit('SHOW_SLIDE_18')
        }
      }
    }

    // SLIDE 19, 24 -> 21
    // save address
    if (
      payload.slideName === context.state.slideNames.SLIDE_19 ||
      payload.slideName === context.state.slideNames.SLIDE_24
    ) {
      context.commit('SET_ADDRESS', payload)
    }

    // SLIDE 21
    // toggle additional inputs for address
    if (payload.formName.name === context.state.formNames.FORM_21_7.name) {
      context.commit('TOGGLE_ADDITIONAL_INPUTS')
      context.commit('SET_OTHER_ADDRESS_CHECKBOX')
    }

    context.commit('SET_NEXT', payload)
    context.commit('SET_SALESFORCE', payload)
    context.commit('SET_LS')
  }
}
